import React, { useEffect } from "react";
import Button from "../../shared/components/Button";

import { Container, ContainerButton, Content, Subtitle, SubtitleMobile, Title, Wrapper } from "./styles";

import NewLogoSVG from "../../components/NewLogo";
import history from "../../services/history";

import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { removeCacheForLogin } from "../../store/modules/auth/actions";

export default function Influencers() {
	const dispatch = useDispatch();

	const { id_influencer } = useParams();

	useEffect(() => {
		dispatch(removeCacheForLogin(false));
		localStorage.setItem("FLUX_INFLUENCER", id_influencer);
	}, [dispatch, id_influencer]);

	/**
	 *
	 * @param {'sign_up' | 'sign_in'} param
	 */
	function goTo(param) {
		const route = {
			sign_up: () => history.push("/onboard/welcome"),
			sign_in: () => history.push("/onboard/login"),
		};

		route[param]();
	}

	return (
		<Container>
			<NewLogoSVG />
			<Content>
				<Wrapper>
					<Title>Entre ou crie sua conta</Title>
					<Subtitle>
						No TradeMap, você encontra tudo sobre seus investimentos e
						muito mais!
					</Subtitle>
					<SubtitleMobile>
						Encontre tudo sobre seus investimentos e muito mais!
					</SubtitleMobile>
					<ContainerButton>
						<Button
							title="Criar uma conta"
							onClick={() => goTo("sign_up")}
						/>
						<Button
							title="Entrar na minha conta"
							btnType="outline"
							onClick={() => goTo("sign_in")}
						/>
					</ContainerButton>
				</Wrapper>
			</Content>
		</Container>
	);
}
